import { Drawer } from 'components/Drawer'
import { Heading } from 'blaze-ui/Heading/Heading'
import { DrawerProps } from 'components/Drawer/Root'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { AspectRatioKey } from 'components/NewFileModal/Types'
import { FileFormatSelection } from 'components/StartWithImageDrawer/FileFormatSelection'

interface Props extends DrawerProps {
  selected: AspectRatioKey
  onSelect: (key: AspectRatioKey) => void
}

export const SelectDesignFormatDrawer = observer(({ selected, onSelect, ...props }: Props) => {
  const { drawersStore } = useRootStore()
  const close = () => drawersStore.closeDrawer()

  return (
    <Drawer.NestedRoot {...props}>
      <Drawer.Portal>
        <Drawer.Content fullHeight color="var(--light-40)">
          <Drawer.InnerContent isSnappedTop>
            <Drawer.Top>
              <Drawer.Close />
              <Drawer.Title asChild>
                <Heading level={5}>Format</Heading>
              </Drawer.Title>
            </Drawer.Top>
            <FileFormatSelection
              onSelect={(key) => {
                onSelect(key)
                close()
              }}
            />
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.NestedRoot>
  )
})
